(() => {
  function initialiseGenericDiscounts(root = document) {
    root.querySelectorAll('[data-generic-discount]:not([data-gdp-initialised])')
      .forEach((deal) => {
        deal.dataset.gdpInitialised = 'true';

        const startDate = deal.dataset.startDate;
        const startTime = deal.dataset.startTime || '00:00';
        const endDate = deal.dataset.endDate;
        const endTime = deal.dataset.endTime || '23:59';
        const expiredText = deal.dataset.expiredText || 'This offer has ended.';
        const hideWhenExpired = deal.dataset.hideWhenExpired === 'true';

        const promotionContent = deal.querySelectorAll('[data-gdp-promotion-content]');
        const expiredMessage = deal.querySelector('[data-gdp-expired]');
        const copyStatus = deal.querySelector('[data-gdp-copy-status]');

        function parseDateTime(date, time) {
          if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return NaN;
          }

          if (!/^\d{2}:\d{2}$/.test(time)) {
            return NaN;
          }

          const timestamp = new Date(`${date}T${time}:00`).getTime();

          return Number.isFinite(timestamp) ? timestamp : NaN;
        }

        const startTimestamp = parseDateTime(startDate, startTime);
        const endTimestamp = parseDateTime(endDate, endTime);

        function updatePromotion() {
          const now = Date.now();

          if (Number.isFinite(startTimestamp) && now < startTimestamp) {
            deal.hidden = true;
            return true;
          }

          if (Number.isFinite(endTimestamp) && now >= endTimestamp) {
            if (hideWhenExpired) {
              deal.hidden = true;
              return false;
            }

            promotionContent.forEach((element) => {
              element.hidden = true;
            });

            if (copyStatus) {
              copyStatus.textContent = '';
            }

            if (expiredMessage) {
              expiredMessage.textContent = expiredText;
              expiredMessage.hidden = false;
            }

            deal.classList.add('is-expired');
            return false;
          }

          deal.hidden = false;
          deal.classList.remove('is-expired');

          promotionContent.forEach((element) => {
            element.hidden = false;
          });

          if (expiredMessage) {
            expiredMessage.hidden = true;
          }

          return true;
        }

        updatePromotion();

        const scheduleTimer = window.setInterval(() => {
          const shouldContinue = updatePromotion();

          if (!shouldContinue) {
            window.clearInterval(scheduleTimer);
          }
        }, 1000);

        const copyButton = deal.querySelector('[data-gdp-copy]');

        if (copyButton) {
          copyButton.addEventListener('click', async () => {
            const code = deal.querySelector('[data-gdp-code]')?.textContent.trim();

            if (!code) return;

            try {
              await navigator.clipboard.writeText(code);

              if (copyStatus) {
                copyStatus.textContent = 'Code copied!';
              }
            } catch (error) {
              if (copyStatus) {
                copyStatus.textContent = `Copy this code: ${code}`;
              }
            }
          });
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseGenericDiscounts());
  } else {
    initialiseGenericDiscounts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseGenericDiscounts(event.target);
  });
})();